import { Box, Typography } from "@mui/material";
import { Autoplay, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import logo4 from "../../assets/oglitz-logo.png";
// SVG files
import p1 from "../../assets/Partners/p1.svg";
import p4 from "../../assets/Partners/p4.svg";
import p5 from "../../assets/Partners/p5.svg";
import p10 from "../../assets/Partners/p10.svg";
import p14 from "../../assets/Partners/p14.png";

// Image files
import p2 from "../../assets/Partners/p2.jpg";
import p3 from "../../assets/Partners/p3.png";
import p6 from "../../assets/Partners/p6.webp";
import p7 from "../../assets/Partners/p7.webp";
import p8 from "../../assets/Partners/p8.jpg";
import p9 from "../../assets/Partners/p9.png";
import p11 from "../../assets/Partners/p11.png";
import p12 from "../../assets/Partners/p12.png";
import p13 from "../../assets/Partners/p13.webp";

import p15 from "../../assets/Partners/p15.jpeg";
import p16 from "../../assets/Partners/p16.webp";
import p17 from "../../assets/Partners/p17.png";
import p18 from "../../assets/Partners/p18.jpeg";
import p19 from "../../assets/Partners/p19.png";
import p20 from "../../assets/Partners/p20.png";
import p21 from "../../assets/Partners/p21.jpeg";
import p22 from "../../assets/Partners/p22.png";
import p23 from "../../assets/Partners/p23.jpeg";
import p24 from "../../assets/Partners/p24.png";
import p25 from "../../assets/Partners/p25.png";
import p26 from "../../assets/Partners/p26.png";
import p27 from "../../assets/Partners/p27.png";
import p28 from "../../assets/Partners/p28.png";



import "swiper/css";
import "swiper/css/navigation";

const partners = [
  { name: "Arada", logo: p1 }, // Done
  { name: "Alef", logo: p2 }, // Done
  { name: "Eagle Hills", logo: p3 },
  { name: "Evolution", logo: p4 }, // Done
  { name: "Al Marwan", logo: p5 }, // Done
  { name: "Tiger", logo: p6 }, // Done
  { name: "Amis", logo: p7 }, // Done
  { name: "Azizi", logo: p8 }, // Done
  { name: "Imtiaz", logo: p9 }, // Done
  { name: "Shorooq", logo: p10 }, // Done
  { name: "Al Majid Developers", logo: p11 }, // Done
  { name: "IFA", logo: p12 }, // Done
  { name: "Beeah Developers", logo: p13 }, // Done
  { name: "Binghatti", logo: p14 }, // Done
  { name: "Majid Al Futtaim", logo: p15 },
  { name: "Al Batha", logo: p16 },
  { name: "MAG Developer", logo: p17 },
  { name: "Damac", logo: p18 },
  { name: "Deyaar", logo: p19 },
  { name: "Acube", logo: p20 },
  { name: "Object One", logo: p21 },
  { name: "Prestige", logo: p22 },
  { name: "Reportage", logo: p23 },
  { name: "Samana", logo: p24 },
  { name: "The Luxe Developers", logo: p25 },
  { name: "GFS", logo: p26 },
  { name: "Mashriq Elite", logo: p27 },
  { name: "Aqaar", logo: p28 },
  // { name: "Swank", logo: p28 },
  // { name: "Oglitz Software Pvt Ltd.", logo: logo4 }, // Done
];

export default function OurPartners() {
  return (
    <Box
      sx={{
        backgroundColor: "#fff",
        py: { xs: 4, md: 4 },
        position: "relative",
      }}
    >
      {/* HEADER */}
      <Box
        sx={{
          maxWidth: 1200,
          mx: "auto",
          px: { xs: 2, md: 4 },
          mb: 1,
          textAlign: "center", // ✅ CENTER ALIGN
        }}
      >
        <Typography
          sx={{
            fontSize: { xs: 28, md: 36 },
            fontWeight: 600,
            color: "var(--color-text-primary)",
            mb: 1,
          }}
        >
          Our{" "}
          <Box component="span" sx={{ color: "var(--color-gold)" }}>
            Partners
          </Box>
        </Typography>

        <Typography
          sx={{
            maxWidth: 560, // ✅ slightly wider for center layout
            mx: "auto", // ✅ center text block
            color: "var(--color-text-muted)",
            lineHeight: 1.8,
          }}
        >
          Driven by a shared commitment to excellence, we collaborate with
          trusted developers and partners to deliver exceptional real estate
          outcomes.
        </Typography>
      </Box>

      {/* SLIDER */}
      <Box sx={{ maxWidth: 1400, mx: "auto", px: { xs: 2, md: 2 } }}>
        <Swiper
          modules={[Navigation, Autoplay]}
          navigation
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
          }}
          loop
          spaceBetween={24}
          breakpoints={{
            0: { slidesPerView: 1 },
            640: { slidesPerView: 3 },
            960: { slidesPerView: 5 },
            1200: { slidesPerView: 6 },
          }}
          style={{
            paddingBottom: "20px",
            paddingTop: "20px",
            paddingLeft: "10px",
            paddingRight: "10px",
            borderRadius: "12px",
          }}
        >
          {partners.map((item) => (
            <SwiperSlide key={item.name}>
              <Box
                sx={{
                  height: 120,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: "18px",
                  backgroundColor: "#fff",
                  // boxShadow: "0 10px 30px rgba(0,0,0,0.06)",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    transform: "translateY(-6px)",
                    boxShadow: "0 20px 50px rgba(0,0,0,0.1)",
                  },
                }}
              >
                <Box
                  component="img"
                  src={item.logo}
                  alt={item.name}
                  sx={{
                    maxHeight: 100,
                    maxWidth: "70%",
                    // filter: "grayscale(100%)",
                    // opacity: 0.75,
                    transition: "all 0.3s ease",
                    "&:hover": {
                      filter: "grayscale(0%)",
                      opacity: 1,
                    },
                  }}
                />
              </Box>
            </SwiperSlide>
          ))}
        </Swiper>
      </Box>

      {/* BOTTOM GOLD LINE */}
      <Box
        sx={{
          position: "absolute",
          bottom: 0,
          left: "5%",
          right: "5%",
          height: "1px",
          background:
            "linear-gradient(90deg, transparent, var(--color-gold), transparent)",
          opacity: 0.6,
        }}
      />
    </Box>
  );
}
